import { DEVELOPER_REALTY_USER_ID, DEVELOPER_REALTY_USER_ID_SPB } from '../../../constants';

export function getUserIdBySubdomain(subdomain: string): number {
  switch (subdomain) {
    case 'spb':
      return DEVELOPER_REALTY_USER_ID_SPB;
    default:
      return DEVELOPER_REALTY_USER_ID;
  }
}
